import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Currency from "../types/Currency";

export default function useCurrencyGet(
    currencyIRI?: string | null,
    options?: CacheQueryOpts<Currency>
): CacheQueryOutput<Currency> {
    const client = useAPIClient();

    // Remove leading "/" from IRI to use as endpoint
    const endpoint = currencyIRI ? currencyIRI.replace(/^\//, "") : null;

    return useCacheQuery<Currency>(
        ["currency", endpoint],
        () => {
            if (!endpoint) throw new Error("No currency IRI provided");
            return client.get<Currency>(endpoint);
        },
        {
            execute: !!endpoint,
            ...options,
        }
    );
}
